import WsService from "./WsService";

const ENDPOINT_BASE = '/payments'

export default class AuthorisationService {
    static retrieveAuthorisationForTransactionIdAndPaymentReference(
        transactionId,
        paymentReference
    ) {
        let url = ENDPOINT_BASE + '/' + paymentReference + '/dual?transaction-id=' + transactionId + ' &status=OPEN';
        return WsService.get(url, {}, 200);
    }
}